/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Team for the assignment dropdown, carrying the ids of its assignable members.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AssignableTeam { 
    readonly id: number;
    name: string;
    readonly memberIds: Array<number>;
}
export const AssignableTeam_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AssignableTeam_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const AssignableTeam_memberIds_Validators: ValidatorFn[] =
    [  Validators.required, ];


